<script setup>
import MainMenu from '~/components/Common/MainMenu.vue'
import MainHeader from '~/components/Common/MainHeader.vue'
import MobileMenu from '~/components/Common/MobileMenu.vue'
import ImpersonationBanner from '~/components/Common/ImpersonationBanner.vue'
import PromotionSubmenuOverlay from '~/components/Promotion/PromotionSubmenuOverlay.vue'
</script>

<template>
  <div class="flex h-screen bg-gray-100">
    <MainMenu />
    <div class="flex-1 flex flex-col overflow-hidden">
      <ImpersonationBanner />
      <MainHeader />
      <div class="relative flex-1 overflow-hidden">
        <PromotionSubmenuOverlay />
        <main class="absolute inset-0 overflow-y-auto bg-gray-100 px-4 md:px-6 py-2">
          <slot />
        </main>
      </div>
    </div>
    <MobileMenu />
  </div>
</template>
